module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"brainDates":"Hjernedates"},"en":{"brainDates":"Brain Dates"}}')
  delete Component.options._Ctor
}
